import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { ConfirmingReportSpecificConfirmingStatusItemListTemplate } from "themes/application/confirming-report/pages";
import { ConfirmingReportSpecificConfirmingStatusItemListViewStore } from "application/confirming-report/stores";

@setCurrentView(rootStore => new ConfirmingReportSpecificConfirmingStatusItemListViewStore(rootStore), "confirmingReportSpecificConfirmingStatusItemListViewStore")
@observer
class ConfirmingReportSpecificConfirmingStatusItemList extends React.Component {
    render() {
        return <ConfirmingReportSpecificConfirmingStatusItemListTemplate {...this.props} />;
    }
}

export default ConfirmingReportSpecificConfirmingStatusItemList;